<template>
  <div class="custom-tick w-4 h-4 flex items-center justify-around custom-tick-border-color custom-tick-background-color" :style="[customCss]">
    <span><i class="fa fa-check text-xs custom-tick-color"></i></span>
  </div>
</template>
<script>
export default {
  name: 'CustomTick',
  props: {
    getThemeSettings: {},
  },
  computed: {
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--custom-tick-border-color': this.themeSettings.progressbar_section
          .complete_bar_color,
        '--custom-tick-background-color': this.themeSettings
          .progressbar_section.uncomplete_bar_color,
      };
    },
  },
};
</script>
<style lang="scss">
.custom-tick{
  height: 24px;
  border-radius: 6px;
  width: 24px;
  float: right;
}
.custom-tick-border-color {
  border: 1px solid var(--custom-tick-border-color);
}
.custom-tick-color {
  color: var(--custom-tick-border-color);
}
.custom-tick-background-color {
  background-color: var(--custom-tick-background-color);
}
</style>
